import React, { FunctionComponent } from 'react'
import { RightSiderMenuOption } from '../../RightSider'
import { Form, Select } from 'antd'
import { useLocalStorage } from 'usehooks-ts'

const { Item } = Form

const SelectOption: FunctionComponent<any> = (props: RightSiderMenuOption) => {
  const { localStorageKey, title, defaultValue, options } = props

  const [enabled, setEnabled] = useLocalStorage(localStorageKey, defaultValue)

  const handleFilter = (input: any, option: any) =>
    option.children.toLowerCase().search(input.toLowerCase()) !== -1

  return (
    <Item label={title}>
      <Select
        defaultValue={enabled}
        size={'large'}
        onChange={setEnabled}
        style={{
          width: '100%'
        }}
        optionFilterProp={'label'}
        placeholder={`Select ${title}`}
        filterOption={handleFilter}
        options={options}
      />
    </Item>
  )
}

export default SelectOption
